module.exports = __webpack_public_path__ + "static/media/motor1.776ea85b.jpg";